import React, { useContext } from 'react';

import styled from 'styled-components';

import { ListContext } from '@contexts/ListContext';

import GooglePlaces from '@components/GooglePlaces/GooglePlaces';
import AddressForm from '@components/Gui/NwForm/AddressForm';
import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Container = styled.div`
    margin: 20px 0;
    .ant-input-prefix {
        color: ${StyleVariables.PrimaryDarkLight};
        font-size: 0.8rem;
    }
`;

const initialValues = {
    Country: undefined,
    City: '',
    County: '',
    State: '',
    Zip: '',
    Street: '',
    Access: '',
};

const AddressSelector = ({ value, onChange, fieldErrors }) => {
    const { cachedList } = useContext(ListContext);
    const countriesList = cachedList.countries.items;

    const handleSetAddress = (address) => {
        const country = countriesList.find((country) => country.Code === address.CountryCode);
        onChange({
            Country: country ? country.Code : undefined,
            City: address.City ? address.City : '',
            County: address.County ? address.County : '',
            State: address.State ? address.State : '',
            Zip: address.Zip ? address.Zip : '',
            Street: address.Street ? address.Street : '',
            Access: '',
        });
    };

    return (
        <Container>
            <GooglePlaces
                clearable
                onSetAddress={handleSetAddress}
                suffix={<NwIcon icon={byPrefixAndName.fasl['search']} />}
            />
            <AddressForm value={value || initialValues} onChange={onChange} fieldErrors={fieldErrors} />
        </Container>
    );
};

export default AddressSelector;
